"use client";
import { Button } from "@/components/ui/button";
import Link from "next/link";

export default function NotFound() {

    return (
        <div className="min-h-screen bg-gradient-to-br from-white via-purple-50/30 to-blue-50/30 relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-[linear-gradient(rgba(82,49,231,0.02)_1.6px,transparent_1.6px),linear-gradient(to_right,rgba(82,49,231,0.02)_1.6px,transparent_1.6px)] bg-[size:24px_24px]" />
            </div>

            {/* Main Content */}
            <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 pt-40 md:pt-44 lg:pt-48 pb-20">
                <div className="text-center max-w-4xl mx-auto">
                    {/* 404 Number with Creative Design */}
                    <div className="relative mb-6">
                        <div className="text-[8rem] md:text-[12rem] font-black text-gray-900/10 select-none">
                            404
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="text-4xl md:text-6xl font-bold text-gray-900">
                                404
                            </div>
                        </div>

                        {/* Floating Code Elements */}
                        <div className="absolute top-4 left-4 text-xs text-gray-400 font-mono animate-bounce">
                            &lt;/&gt;
                        </div>
                        <div className="absolute top-8 right-8 text-xs text-gray-400 font-mono animate-bounce delay-300">
                            {`{ }`}
                        </div>
                        <div className="absolute bottom-8 left-8 text-xs text-gray-400 font-mono animate-bounce delay-700">
                            &lt;/&gt;
                        </div>
                        <div className="absolute bottom-4 right-4 text-xs text-gray-400 font-mono animate-bounce delay-1000">
                            {`( )`}
                        </div>
                    </div>

                    {/* Main Message */}
                    <div className="space-y-4 mb-8">
                        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-3">
                            Oops! Page{" "}
                            <span className="bg-gradient-to-r from-[#5231E7] to-[#764AF1] bg-clip-text text-transparent">
                                Not Found
                            </span>
                        </h1>

                        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
                            Looks like this page took a wrong turn in the code.
                            Don't worry, even the best developers make mistakes!
                        </p>
                    </div>



                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        <Link href="/">
                            <Button
                                variant="outline"
                                className="shadow-none rounded-full cursor-pointer px-4 py-2 font-medium text-base"
                            >
                                <p>Go Home</p>
                            </Button>
                        </Link>

                        <Link href="/#software-solutions">
                            <Button className="shadow-none rounded-full cursor-pointer px-4 py-2 font-medium text-base">
                                <p>Explore Our Services</p>
                            </Button>
                        </Link>
                    </div>


                </div>




            </div>
        </div>
    );
} 